import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Project } from '../types';

interface ProjectCardProps {
  project: Project;
  onClick: () => void;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project, onClick }) => {
  return (
    <button 
      onClick={onClick}
      className="group text-left relative overflow-hidden rounded-2xl bg-zinc-900/40 border border-white/5 hover:border-red-500/30 transition-all duration-500 w-full"
    >
      <div className="aspect-[16/10] overflow-hidden">
        <img 
          src={project.image} 
          alt={project.title} 
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 block"
        />
      </div>
      
      <div className="p-6 relative">
        <div className="flex justify-between items-center mb-1">
          <span className="text-[10px] font-mono text-zinc-500 tracking-wider uppercase">{project.year}</span>
          <ArrowUpRight className="w-4 h-4 text-zinc-600 group-hover:text-red-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
        </div>
        <h3 className="text-xl font-bold text-white mb-2 group-hover:text-white transition-colors">{project.title}</h3>
        <p className="text-xs text-zinc-400 line-clamp-2 leading-relaxed mb-4">{project.description}</p>
        
        <div className="flex flex-wrap gap-1.5">
          {project.tags.slice(0, 3).map(tag => (
            <span key={tag} className="text-[9px] font-mono px-2 py-0.5 rounded-full bg-white/5 border border-white/5 text-zinc-400">
              {tag}
            </span>
          ))}
          {project.tags.length > 3 && (
            <span className="text-[9px] font-mono px-2 py-0.5 text-zinc-600">+{project.tags.length - 3}</span>
          )}
        </div>
      </div>
    </button>
  );
};

export default ProjectCard;